export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10942.47fa5a25.jpg";